import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { switchMap, tap } from 'rxjs/operators';
import { Page, Pageable } from 'src/app/model/rest/base';
import { ModalComponent } from '../modal/modal.component';
import {SchoolV3RestService} from "../../services/rest/v3/school-rest.service";
import {
  V3StudentsFeePaymentConfirmationDetails,
  V3StudentsFeeRequest,
} from "../../model/v3/schools";

@Component({
    selector: 'app-admin-school-payment-list',
    templateUrl: './admin-school-payment-list.component.html',
    styleUrls: ['./admin-school-payment-list.component.scss'],
    standalone: false
})
export class AdminSchoolPaymentListComponent implements OnInit {
  studentsFeeRequest: Page<V3StudentsFeeRequest>;
  paymentConfirmation: V3StudentsFeePaymentConfirmationDetails = {} as V3StudentsFeePaymentConfirmationDetails;
  schoolId: number;
  pageable = new Pageable(0, 10, ['qId,DESC']);
  selectedFeeRequestId: number;
  @ViewChild('confirmationModal', { static: true })
  confirmationModal: ModalComponent;
  constructor(
    private route: ActivatedRoute,
    private schoolV3Rest: SchoolV3RestService,
  ) {}

  ngOnInit(): void {
    this.route.parent.paramMap
      .pipe(
        tap((params) => (this.schoolId = +params.get('schoolId'))),
        switchMap((_) => this.loadStudentsFeeRequest())
      )
      .subscribe();
  }

  loadStudentsFeeRequest() {
    return this.schoolV3Rest
      .listSchoolFees(this.schoolId, this.pageable)
      .pipe(
        tap(
          (studentsFeeRequest) => (this.studentsFeeRequest = studentsFeeRequest)
        )
      );
  }

  onConfirmPayment() {
    this.schoolV3Rest
      .savePaymentConfirmation(
        this.schoolId,
        this.selectedFeeRequestId,
        this.paymentConfirmation
      )
      .pipe(switchMap((_) => this.loadStudentsFeeRequest()))
      .subscribe();
    this.confirmationModal.hide();
  }

  confirmPayment(feeRequestId: number) {
    this.selectedFeeRequestId = feeRequestId;
    this.confirmationModal.show();
  }

  isPaid(paymentConfirmation: V3StudentsFeeRequest) {
    return (
      paymentConfirmation.confirmation.paymentDate &&
      paymentConfirmation.confirmation.paymentOrderId
    );
  }
  switchPage($event: Pageable) {
    this.pageable = $event;
    this.loadStudentsFeeRequest().subscribe();
  }
}
